import { useSearchStore } from './stores/search/useSearchStore';

export const useHasNoLocation = () => {
  const placeIds = useSearchStore((state) => state.placeIds);
  const multiPolygon = useSearchStore((state) => state.multiPolygon);
  return !(placeIds?.length || multiPolygon);
};
